export const emptyComponentRow = (id)=>({
        id,
        name: '',
        rate: ''
    });
export const toFormValues = (preset, newId)=>{
    if (preset == null) {
        return {
            name: '',
            components: [
                emptyComponentRow(newId)
            ]
        };
    }
    return {
        name: preset.name,
        components: preset.components.map((c)=>({
                id: c.id,
                name: c.name,
                rate: c.rate
            }))
    };
};
export const toPreset = (values, existing, newComponentId)=>{
    var _ref, _ref1;
    return {
        id: (_ref = existing === null || existing === void 0 ? void 0 : existing.id) !== null && _ref !== void 0 ? _ref : newComponentId(),
        name: values.name.trim(),
        status: (_ref1 = existing === null || existing === void 0 ? void 0 : existing.status) !== null && _ref1 !== void 0 ? _ref1 : 'active',
        components: values.components.map((c)=>({
                id: c.id,
                name: c.name.trim(),
                rate: c.rate
            })),
        mappingStatus: existing === null || existing === void 0 ? void 0 : existing.mappingStatus
    };
};
export const validatePreset = (param)=>{
    let { values, duplicateName, errorTexts } = param;
    const errors = {
        components: values.components.map(()=>({}))
    };
    if (values.name.trim().length === 0) {
        errors.name = errorTexts.missingRateName;
    } else if (duplicateName) {
        errors.name = errorTexts.duplicateName;
    }
    values.components.forEach((c, index)=>{
        if (c.name.trim().length === 0) {
            errors.components[index].name = errorTexts.missingComponentName;
        }
        const rate = parseFloat(c.rate);
        if (c.rate.trim().length === 0 || Number.isNaN(rate)) {
            errors.components[index].rate = errorTexts.missingRate;
        } else if (rate <= 0) {
            errors.components[index].rate = errorTexts.rateNotPositive;
        }
    });
    return errors;
};
export const hasErrors = (errors)=>errors.name != null || errors.components.some((c)=>c.name != null || c.rate != null);
